// frontend/src/selectors/orderSelectors.js

const EMPTY_BRANCH = Object.freeze({
  loading: false,
  success: false,
  error: null,
  errorCode: "",
  status: 0,
  requestId: "",
  retryAfterSeconds: 0,
  message: "",
});

function getBranch(state, key, fallback = {}) {
  return state?.order?.[key] || fallback;
}

export const selectOrderState = (state) => state?.order || {};

export const selectOrderCreateState = (state) =>
  getBranch(state, "create", {
    ...EMPTY_BRANCH,
    order: null,
    orderNumber: "",
    reused: false,
    ignored: false,
    idempotencyKey: "",
    issues: [],
    failures: [],
    inventoryFailures: [],
  });

export const selectCreatedOrder = (state) =>
  selectOrderCreateState(state).order || null;

export const selectCreatedOrderNumber = (state) =>
  selectOrderCreateState(state).orderNumber || "";

export const selectOrderCreateIssues = (state) =>
  selectOrderCreateState(state).issues || [];

export const selectOrderCreateFailures = (state) =>
  selectOrderCreateState(state).failures || [];

export const selectOrderCreateInventoryFailures = (state) =>
  selectOrderCreateState(state).inventoryFailures || [];

export const selectMyOrdersState = (state) =>
  getBranch(state, "listMy", {
    ...EMPTY_BRANCH,
    orders: [],
    page: 1,
    limit: 20,
    pages: 1,
    count: 0,
    pagination: null,
  });

export const selectMyOrders = (state) =>
  selectMyOrdersState(state).orders || [];

export const selectOrderDetailsState = (state) =>
  getBranch(state, "details", {
    ...EMPTY_BRANCH,
    order: null,
  });

export const selectOrderDetails = (state) =>
  selectOrderDetailsState(state).order || null;

export const selectOrderStatusState = (state) =>
  getBranch(state, "status", {
    ...EMPTY_BRANCH,
    order: null,
    orderNumber: "",
    orderStatus: "",
    paymentStatus: "",
    customerCheckout: null,
  });

export const selectOrderStatusOrder = (state) =>
  selectOrderStatusState(state).order || null;

export const selectOrderCustomerCheckout = (state) => {
  const detailsOrder = selectOrderDetails(state);
  const statusState = selectOrderStatusState(state);

  return (
    detailsOrder?.customerCheckout ||
    statusState.customerCheckout ||
    statusState.order?.customerCheckout ||
    null
  );
};

export const selectOrderPaymentWindowExpiresAt = (state) => {
  const detailsOrder = selectOrderDetails(state);
  const customerCheckout = selectOrderCustomerCheckout(state);

  return (
    detailsOrder?.paymentWindowExpiresAt ||
    customerCheckout?.paymentWindowExpiresAt ||
    null
  );
};

export const selectOrderCancelState = (state) =>
  getBranch(state, "cancel", {
    ...EMPTY_BRANCH,
    order: null,
    paymentAction: null,
    refundAction: null,
    eligibility: null,
    idempotencyKey: "",
  });

export const selectCancelledOrder = (state) =>
  selectOrderCancelState(state).order || null;

export const selectAnyOrderBusy = (state) => {
  const order = selectOrderState(state);

  return Boolean(
    order?.create?.loading ||
    order?.listMy?.loading ||
    order?.details?.loading ||
    order?.status?.loading ||
    order?.cancel?.loading,
  );
};
